module.exports = __webpack_public_path__ + "img/fire-smoke.b40de299.svg";